import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { Cloud } from '@react-three/drei';
import * as THREE from 'three';

const Protostar = ({ position, scale = 1 }) => {
    const groupRef = useRef();
    const coreRef = useRef();

    useFrame((state) => {
        const t = state.clock.getElapsedTime();
        if (coreRef.current) {
            // Unstable flickering
            coreRef.current.intensity = 1 + Math.sin(t * 5) * 0.5;
        }
        if (groupRef.current) {
            groupRef.current.rotation.y = t * 0.1;
        }
    });

    return (
        <group ref={groupRef} position={position} scale={scale}>
            {/* 1. Dim Core */}
            <mesh>
                <sphereGeometry args={[0.25, 32, 32]} />
                <meshStandardMaterial 
                    color="#ffccaa" 
                    emissive="#ff8800"
                    emissiveIntensity={3} 
                    roughness={0.8}
                />
                <pointLight ref={coreRef} distance={5} intensity={3} color="#ffaa00" />
            </mesh>

            {/* 2. Dusty Envelope */}
            <Cloud 
                opacity={0.4} 
                speed={0.2} 
                width={1.5} 
                depth={1.5} 
                segments={10} 
                color="#886644" // Brownish dust
            />
        </group>
    );
};

export default Protostar;